import { WalletRequests } from '@/services/http/wallet-requests';

export default {
  namespaced: true,
  state: {
    wallet: 0,
  },
  getters: {
    getWalletBalance(state) {
      let availableAmount = state.wallet?.data[0]?.availableAmount.toFixed(2);
      const availableAmountInArray = availableAmount?.split('.');

      /**
         * If fraction part of amount is more than 2 digits, this condition will work and show only two digit in fraction part.
      */
      if (availableAmountInArray[1] && availableAmountInArray[1].length >= 2) {
        availableAmount = `${availableAmountInArray[0]}.${availableAmountInArray[1].slice(0, 2)}`;
      }

      return `${availableAmount} ${state.wallet?.data[0]?.currencyCode}`;
    },
    getWalletAmountRaw(state) {
      return state.wallet?.data[0]?.availableAmount;
    },
  },
  mutations: {
    setWallet(state, payload) {
      state.wallet = payload;
    },
  },
  actions: {
    async getWallets({ commit }) {
      const [response] = await WalletRequests.getWallets();
      commit('setWallet', response);
      return response;
    },
  },
};
